import React, { useState, useEffect } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Select from 'react-select';
import Switch from "react-switch";
import { loadVendors } from '../../Redux/Actions/ActionVendors';
import { postBanner } from '../../Redux/Actions/ActionBanner';
import { SendNotificationn } from '../../Redux/Actions/ActionAuth';

function SendNotification({ open, setOpen }) {
    let dispatch = useDispatch();
    let langLocal = localStorage.getItem('absherLang');
    const [t, i18n] = useTranslation();
    const [title, settitle] = useState('');
    const [body, setbody] = useState('')
    const [loadBtn, setloabBtn] = useState(false);
    const FunSubmit = (e) => {
        e.preventDefault()
        console.log(title)
        console.log(body)
        dispatch(SendNotificationn(title,body, setloabBtn))
    }
    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center={false}
            classNames={{
                modal: "popAdd",
            }}
            focusTrapped={false}
        >
            <div className='popAddForm' dir={langLocal == "ar" ? "rtl" : "ltr"} >
                <h3 className={langLocal == 'ar' ? "textAlignRight" : ""}>Send Notifications</h3>
                <form>
                    <div className='input_row' >
                        <div className='one_input_row'>
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('title')}</span>
                            </div>
                            <input type="text" placeholder={t('title')} onChange={(e) => settitle(e.target.value)} />
                        </div>
                        <div className='one_input_row' >
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('body')}</span>
                            </div>
                            <textarea type="text" placeholder={t('body')} onChange={(e) => setbody(e.target.value)} />
                        </div>
                    </div>
                </form>
                <div className='div_btn' ><button onClick={FunSubmit}  >
                    {
                        loadBtn ? "Loading ... " : <>{t('send')}</>
                    }
                </button></div>
            </div>
        </RModal>
    )
}

export default SendNotification